var map = {
	"./1.jpg": 62820,
	"./2.jpg": 99959,
	"./3.jpg": 29157,
	"./4.jpg": 23947,
	"./5.jpg": 68886,
	"./6.jpg": 12996,
	"./7.jpg": 61782,
	"./8.jpg": 67556
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 44135;